import { APP_BASE_HREF, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenubarModule } from 'primeng/menubar';
import { TooltipModule } from 'primeng/tooltip';
import { KeyFilterModule } from 'primeng/keyfilter';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';
import { CarouselModule } from 'primeng/carousel';
import { FileUploadModule } from 'primeng/fileupload';
import { AppComponent } from './app.component';
import { DataService, UIBlockingStatus } from './common/data.service';
import { AuthGuardService } from './common/auth-guard.service';
import { AppTokenHandler } from './common/app-token-handler';
import { ErrorHandler } from '@angular/core';
import { AppErrorHandler } from './common/app-error-handler';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http';
import { WinAuthInterceptor } from './common/interceptor';
import { HomeComponent } from './inside-of-application/home/home.component';
import { DashboardComponent } from './inside-of-application/dashboard/dashboard.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { DummyLoginComponent } from './out-of-application/dummy-login/dummy-login.component';
import { AlertComponent } from './out-of-application/alert/alert.component';
import { ProgressComponent } from './out-of-application/progress/progress.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { OrderListModule } from 'primeng/orderlist';
import { DataViewModule } from 'primeng/dataview';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { NgMarqueeModule } from 'ng-marquee-improved';
import { ViewRequestComponent } from './out-of-application/view-request/view-request.component';
import { BnNgIdleService } from 'bn-ng-idle';
import { AppHeaderComponent } from './inside-of-application/shared/layout/app-header/app-header.component';
import { AppSidebarComponent } from './inside-of-application/shared/layout/app-sidebar/app-sidebar.component';
import { AppFooterComponent } from './inside-of-application/shared/layout/app-footer/app-footer.component';
import { BPRecordsComponent } from './inside-of-application/bprecords/bprecords.component';
import { ToolbarModule } from 'primeng/toolbar';
import { BprecordsDetailsComponent } from './inside-of-application/bprecords-details/bprecords-details.component';
import { ECCIDDetailsComponent } from './inside-of-application/eccid-details/eccid-details.component';
import { UploadExcelDataComponent } from './inside-of-application/upload-excel-data/upload-excel-data.component';
import { PanelModule } from 'primeng/panel';
import { AppInsightsService } from './common/app-insights.service';
// import { MsalModule } from '@azure/msal-angular';

@NgModule({
    declarations: [
        AppComponent, HomeComponent, DashboardComponent,
        BadRequestComponent, PageNotFoundComponent, LogoutComponent, UnAuthorizeComponent,
        SessionExpiredComponent, LoginComponent, DummyLoginComponent, AlertComponent, ProgressComponent,
        ViewRequestComponent, AppHeaderComponent, AppSidebarComponent, AppFooterComponent, BPRecordsComponent,
        BprecordsDetailsComponent,
        ECCIDDetailsComponent,
        UploadExcelDataComponent,
    ],
    imports: [
        BrowserModule, BrowserAnimationsModule, ReactiveFormsModule, AppRoutingModule, HttpClientModule,
        ToastModule, MessageModule, DropdownModule, CheckboxModule, FileUploadModule, MultiSelectModule, MenubarModule, TooltipModule,
        KeyFilterModule, DialogModule, TableModule, CardModule, CalendarModule,
        CarouselModule, BlockUIModule, ProgressSpinnerModule, RadioButtonModule, FormsModule,
        AccordionModule, OrderListModule, DataViewModule, ButtonModule, InputTextareaModule,
        AutoCompleteModule, HttpClientJsonpModule, NgMarqueeModule, ToolbarModule, PanelModule,
    //     MsalModule.forRoot({
    //         auth: {
    //             clientId: "1795007c-d7f6-40e3-992c-38a5e007c432",
    //             authority: "https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c",
    //             redirectUri: "http://localhost:4200",
    //             postLogoutRedirectUri: "http://localhost:4200",
    //             // redirectUri: "http://localhost/ClientMaster",
    //             // postLogoutRedirectUri: "http://ClientMaster/ClientMaster/#/logout",
    //             // redirectUri: "https://inqa.ey.com/clientmaster",
    //             // postLogoutRedirectUri: "https://inqa.ey.com/clientmaster",
    //             // redirectUri: "https://inclientmaster-uat.ey.net",
    //             // postLogoutRedirectUri: "https://inclientmaster-uat.ey.net",
    //             navigateToLoginRequestUrl: true
    //         },
    //         cache: {
    //             cacheLocation: "localStorage",
    //             storeAuthStateInCookie: false, // set to true for IE 11
    //         },
    //     }, {
    //         consentScopes: [
    //             "user.read",
    //             "openid",
    //             "profile"
    //         ],
    //         popUp: true,
    //         // interactionType: InteractionType.Popup,
    //         // authRequest: {
    //         //     scopes: ['user.read']
    //         //   },
    //         unprotectedResources: [],
    //         protectedResourceMap: [
    //             ['http://graph.microsoft.com/v1.0/me', ['user.read']]
    //         ],
    //         extraQueryParameters: {}
    //     }
    //     )
    ],
    providers: [
        DataService, AppTokenHandler, AuthGuardService,AppInsightsService, UIBlockingStatus, MessageService, 
        {
            provide: HTTP_INTERCEPTORS,
            useClass: WinAuthInterceptor,
            multi: true,
            // useValue: '/'
        },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        DatePipe,
        BnNgIdleService

        /*DataService, AppTokenHandler, AuthGuardService, UIBlockingStatus, MessageService,
        { provide: HTTP_INTERCEPTORS, useClass: WinAuthInterceptor,  multi: true, useValue: '/'},
        { provide: ErrorHandler, useClass: AppErrorHandler },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        DatePipe,
        BnNgIdleService*/
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
